import { render, staticRenderFns } from "./setAddressProfile.vue?vue&type=template&id=4606d60b"
import script from "./setAddressProfile.vue?vue&type=script&lang=js"
export * from "./setAddressProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports